import React from "react";
import Breadcrumb from "../../core/common/Breadcrumb/breadcrumb";
import { useContentLogic } from "./hooks/useContentLogic";
import CourseSidebar from "./components/CourseSidebar";
import TextContent from "./components/renderers/TextContent";
import AiSpeakingAgent from "./components/renderers/AiSpeakingAgent";
import ChatInterface from "./components/renderers/ChatInterface";

const Contents = () => {
    const {
        title, isLoading, successPercentage, isTopicOnlyMode, isChatMode,
        groupedSectionsByLevel, activeContentId, activeContentIndices,
        selectedContent, selectedContentUrl, userAnswer, setUserAnswer,
        isSubmitting, answerResults, answerResult, setAnswerResult,
        aiLoading, aiSession, iframeRef,
        conversation, chatInput, isChatLoading, setChatInput, handleChatSend,
        isPrevDisabled, isNextDisabled, selectedLevel,
        handleTopicSelect, handleContentSelect, handleSubmitAnswer, handleNext, handlePrevious
    } = useContentLogic();

    const renderContent = () => {
        if (!selectedContent) {
            return (
                <div className="d-flex justify-content-center align-items-center bg-light" style={{ height: "650px" }}>
                    <p>Select a module from the left to start learning.</p>
                </div>
            );
        }

        switch (selectedContent.content_type_id) {
            case 1: // TEXT
                return (
                    <TextContent
                        content={selectedContent}
                        userAnswer={userAnswer}
                        setUserAnswer={setUserAnswer}
                        isSubmitting={isSubmitting}
                        handleSubmitAnswer={handleSubmitAnswer}
                        answerResults={answerResults}
                        answerResult={answerResult}
                        setAnswerResult={setAnswerResult}
                    />
                );
            case 2: // INTERACTIVE
                return (
                    <iframe
                        src={selectedContentUrl!}
                        width="100%"
                        style={{ height: "650px" }}
                        frameBorder="0"
                        allowFullScreen={true}
                        allow="geolocation *; microphone *; camera *; midi *; encrypted-media *; autoplay *;"
                        title="Interactive Content"
                    />
                );
            case 998: // CHAT
                return (
                    <ChatInterface
                        messages={conversation}
                        input={chatInput}
                        setInput={setChatInput}
                        loading={isChatLoading}
                        onSend={handleChatSend}
                        topicName={selectedContent.title}
                        levelName={selectedLevel}
                    />
                );
            case 999: // AI SPEAK
                if (isTopicOnlyMode) {
                    //@ts-ignore
                    return <AiSpeakingAgent aiLoading={aiLoading} aiSession={aiSession} iframeRef={iframeRef} />;
                }
                return (
                    <div className="d-flex justify-content-center align-items-center bg-light flex-column" style={{ height: "650px" }}>
                        <div className="text-center p-5">
                            <i className="isax isax-book-1 mb-3 text-primary" style={{fontSize: "64px"}}></i>
                            <h3 className="fw-bold text-dark mb-2">{selectedContent.title}</h3>
                            <p className="text-muted">Selected Topic</p>
                        </div>
                    </div>
                );
            default:
                return <div className="d-flex justify-content-center align-items-center bg-light" style={{ height: "650px" }}><p>This content type is not supported.</p></div>;
        }
    };

    return (
        <>
            <Breadcrumb title={title} />
            <div className="content pt-0">
                <div className="container-fluid">
                    <div className="course-watch-section">
                        <div className="row">
                            <CourseSidebar
                                isLoading={isLoading}
                                isTopicOnlyMode={isTopicOnlyMode}
                                isChatMode={isChatMode}
                                successPercentage={successPercentage}
                                groupedSectionsByLevel={groupedSectionsByLevel}
                                activeContentId={activeContentId}
                                activeContentIndices={activeContentIndices}
                                //@ts-ignore
                                handleTopicSelect={handleTopicSelect}
                                handleContentSelect={handleContentSelect}
                            />
                            <div className="col-lg-8">
                                <div className="course-watch-content">
                                    <div className="course-video-player mb-4">
                                        {renderContent()}
                                    </div>
                                    {selectedContent && (
                                        <div className="d-flex justify-content-between mt-3">
                                            <button className="btn btn-primary d-flex align-items-center" onClick={handlePrevious} disabled={isPrevDisabled}>
                                                <i className="isax isax-arrow-left-2 me-2" /> Previous
                                            </button>
                                            <button className="btn btn-primary d-flex align-items-center" onClick={handleNext} disabled={isNextDisabled}>
                                                Next <i className="isax isax-arrow-right-3 ms-2" />
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Contents;